import styled from 'styled-components';

export const ReportsListContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  width: 100%;
  max-width: 85%;
  margin: 0 auto;
  border-radius: 8px;

  @media (max-width: 768px) {
    padding: 8px;
    gap: 8px;
    max-width: 100%;
    margin: 0;
  }
`;
